import React from "react"
import Meal from "./Meal"
import {addMeal} from "../service.js";



export default function MealList({mealsFromServer,updateMeals}){
  function addItem(){
    //add item to UI (new meals stay at the top - that's where the + button is)
    updateMeals((previousMeals) => {
      const newMeal = {id:undefined,label:"new",ingredients:[],inScope:false,mealType:"Other"}
      //the server appends new meals at MAX(position)+1, so stamp that value here:
      //the shopping list dedupe gives the lowest position the win, and a meal
      //added this session must count as the newest so it can never shadow an
      //established row (the "new meal shadows until refresh" bug)
      const positions = previousMeals.map((meal) => meal.position).filter((p) => typeof p === "number")
      if (positions.length > 0) {
        newMeal.position = Math.max(...positions) + 1
      }
      return [newMeal,...previousMeals]
    })
    //update state with new UUID once the server responds
    addMeal("new").then((data) => {
      updateMeals((previousMeals) => {
        const newMealList = previousMeals.map(
          (meal) => {
            return meal.id === undefined ? {...meal, id : data.id} : meal
        })
        return newMealList
      })
    })
  }

  return(
    <div className="mealList">
      <button className="mealList--button" onClick={addItem}>
        +
      </button>
      {
        mealsFromServer.map(
          (meal,index) => meal.id !== "0" ?
          <Meal
            id =          {meal.id} 
            ingredients = {meal.ingredients}
            inScope =     {meal.inScope}
            mealType =    {meal.mealType}
            justMade =    {index===0 && meal.label === "new"}
            label =       {meal.label}
            expanded =    {false}
            key =         {index}
            index =       {index}

            updateMeals           = {updateMeals}
          /> : null
        )
      }
    </div>
  )
}